import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';
import serializeQueryParams from '../../utils/url/serialize-query-params';
import { PAYMENT_METHOD_KEYS } from '../../routes/payment/payment.constants';

export type AdyeConfig = {
    configuration: { merchantId: string; merchantName?: string; gatewayMerchantId?: string };
    name: string;
    type: string;
};

export type PaymentOptionsDataType = {
    id: string;
    showFallbackMethods: boolean;
    allowedPaymentMethods: string[];
    kushkiEnv: {
        limits: { KushkiCash: string; KushkiCard: string; KushkiTransfer: string };
        merchantId: string;
        inTestEnvironment: boolean;
    };
    amazonPay: { merchantId: string; publicKey: string };
    adyen: AdyeConfig[];
    paypalCheckout: { isVaultRefused: boolean; id_token?: string };
    userCountry: string;
    orderToken: string;
    currencies: { [key in PAYMENT_METHOD_KEYS]: string };
    loaded: boolean;
    recentlyUsedPaymentMethod: PAYMENT_METHOD_KEYS | null;
};

type GetPaymentOptionsParams = {
    currencyCode?: string;
    countryCode?: string;
    materialId?: string;
};

const CART_FINAL_PRICE_ZERO_MESSAGE = 'Cart\'s final price is zero';

const getPaymentOptions = async (requestParams: GetPaymentOptionsParams): Promise<PaymentOptionsDataType> => {
    const queryParams = serializeQueryParams();
    const isTestOverride = Boolean(queryParams.region);
    const params: GetPaymentOptionsParams = isTestOverride
        ? { countryCode: queryParams.region, currencyCode: queryParams.currency }
        : { ...requestParams };

    if (queryParams.materialId) {
        params.materialId = queryParams.materialId;
    }

    try {
        const response = (await axios.get(API_URLS.PAYMENT_OPTIONS, { params })) as unknown as PaymentOptionsDataType;

        return { ...response, loaded: true };
    } catch (error: unknown) {
        const err = error as { data?: { message?: string } };

        if (err?.data?.message === CART_FINAL_PRICE_ZERO_MESSAGE) {
            return { loaded: true } as PaymentOptionsDataType;
        }

        throw error;
    }
};

export default getPaymentOptions;
